export default {"src":"/_next/static/media/Crotone.e7a00f20.svg","height":79,"width":52,"blurWidth":0,"blurHeight":0};